// Named import `parsePhoneNumber` is same as `parsePhoneNumberWithError`
import {
    AsYouType as _AsYouType,
    CountryCallingCode,
    CountryCode,
    getCountryCallingCode as _getCountryCallingCode,
    parsePhoneNumberFromString as _parsePhoneNumber,
    PhoneNumber
} from 'libphonenumber-js/core';

import metadata from '~metadata/metadata';

/** Display calling code prefix, i.e. `+<country calling code>`, if `INTERNATIONAL` */
export type PhoneNumberDisplayFormat = 'INTERNATIONAL' | 'NATIONAL';

export type PhoneNumberValueFormat =
    | PhoneNumberDisplayFormat
    | 'E.164'
    | 'E.164-digits'
    | 'NATIONAL-digits';

export const getCountryCallingCode = (countryCode: CountryCode) =>
    _getCountryCallingCode(countryCode, metadata);

export const getCountryCallingCodePrefix = (countryCode: CountryCode) =>
    `+${getCountryCallingCode(countryCode)}`;

export const getCountryCodeByCallingCode = (countryCallingCode: CountryCallingCode) => {
    return metadata.country_calling_codes[countryCallingCode]?.[0];
};

export const ensureCountryCallingCodePrefix = (value: string, countryCode: CountryCode) => {
    const prefix = getCountryCallingCodePrefix(countryCode);
    const number = (value ?? '').trimStart();
    if (number.startsWith(prefix)) {
        return number;
    }
    if (!number || number[0] === '+') {
        return prefix;
    }

    return prefix + number;
};

export function createAsYouType(countryCode?: CountryCode) {
    return new _AsYouType(countryCode, metadata);
}

export const parsePhoneNumber = (value: string, countryCode: CountryCode) =>
    _parsePhoneNumber(value, countryCode, metadata);

export const formatValue = (phoneNumber: PhoneNumber, format: PhoneNumberValueFormat) => {
    if (format === 'E.164-digits') {
        return phoneNumber.number.substr(1);
    } else if (format === 'NATIONAL-digits') {
        // HACK: this is different than using PhoneNumber.nationalNumber, which won't preserve the
        // leading "0". https://gitlab.com/catamphetamine/libphonenumber-js#phonenumber
        return phoneNumber.formatNational().replace(/[_()\-\s]/g, '');
    }

    return phoneNumber.format(format);
};

export const getDisplayFieldName = (fieldName: string) => `_${fieldName}DisplayPhantom`;
